
import { computed, defineComponent, PropType } from 'vue';
import CteDocumentos from './CteDocumentos.vue';
import CteImpostos from './CteImpostos.vue';
import CteDetalheFinanceiro from './CteDetalheFinanceiro.vue';
import { ICteDocumentoReferenciado } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteDocumentoReferenciado';
import { ICteDetalhePagamento } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteDetalhePagamento';
import { ICteImposto } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteImposto';

function criarImpostoPadrao(): ICteImposto {
  return {
    valorTotalTributosAproximado: 0,
    icms: {
      cstIcms: '',
      baseCalculo: 0,
      aliquota: 0,
      valorIcms: 0,
      valorBaseCalculoSt: 0,
      valorIcmsSt: 0,
      percentualReducaoBaseCalculo: 0,
    },
    iss: {
      baseCalculo: 0,
      aliquota: 0,
      valorIss: 0,
      codigoMunicipioFatoGerador: 0,
    },
    pis: {
      cstPis: '',
      baseCalculo: 0,
      aliquota: 0,
      valorPis: 0,
    },
    cofins: {
      cstCofins: '',
      baseCalculo: 0,
      aliquota: 0,
      valorCofins: 0,
    },
  };
}

export default defineComponent({
  name: 'CteAbas',
  components: {
    CteDocumentos,
    CteImpostos,
    CteDetalheFinanceiro,
  },
  props: {
    documentos: {
      type: Array as PropType<ICteDocumentoReferenciado[]>,
    },
    imposto: {
      type: Object as PropType<ICteImposto | null>,
      default: null,
    },
    detalhesPagamento: {
      type: Array as PropType<ICteDetalhePagamento[]>,
      default: () => [],
    },
    empresa: {
      type: Number,
      required: true,
    },
    valorFrete: {
      type: Number,
      default: 0,
    },
    codigoTipoOperacao: {
      type: Number,
      default: 0,
    },
    codigoPessoa: {
      type: Number,
      default: 0,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:documentos', 'update:imposto', 'update:detalhesPagamento'],
  setup(props, { emit }) {
    const impostoModel = computed({
      get: () => props.imposto ?? criarImpostoPadrao(),
      set: (value: ICteImposto | null) => emit('update:imposto', value),
    });

    const detalhesPagamentoModel = computed({
      get: () => props.detalhesPagamento ?? [],
      set: (value: ICteDetalhePagamento[]) => emit('update:detalhesPagamento', value),
    });

    return {
      impostoModel,
      detalhesPagamentoModel,
    };
  },
});
